<template>
  <div>
    <template-one :data="one" fontBg="01"></template-one>
    <template-two :data="two" fontBg="02"></template-two>
    <template-three :data="three" fontBg="03"></template-three>
    <template-two :data="four" fontBg="04" bgColor="#FFFFFF"></template-two>
  </div>
</template>

<script>
import templateOne from "./templateOne";
import templateTwo from "./templateTwo";
import templateThree from "./templateThree";
export default {
  components: {
    templateOne,
    templateTwo,
    templateThree,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      one: {},
      two: {},
      three: {},
      four: {},
    };
  },
  watch: {
    data() {
      this.dataConvert();
    },
  },
  methods: {
    dataConvert() {
      let data = this.data;
      if (data.length < 1) {
        return;
      }
      this.getDataOne(data[0]);
      this.getDataTwo(data[1]);
      this.getDataThree(data[2]);
      this.getDataFour(data[3]);
    },
    getDataFour(obj) {
      if (obj) {
        let four = {
          title: obj.title,
          subTitle: obj.subTitle,
          url: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          four.url = tuWen.image.url;
        }
        this.four = four;
      }
    },
    getDataThree(obj) {
      if (obj) {
        let three = {
          title: obj.title,
          subTitle: obj.subTitle,
          bg: "",
          url1: "",
          url2: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          three.bg = tuWen.textBgImage.url;
        }
        let lieBiao = obj.lieBiao;
        if (lieBiao) {
          three.url1 = lieBiao[0].image.url;
          three.url2 = lieBiao[1].image.url;
        }
        this.three = three;
      }
    },
    getDataTwo(obj) {
      if (obj) {
        let two = {
          title: obj.title,
          subTitle: obj.subTitle,
          bg: "",
          url: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          two.url = tuWen.image.url;
          two.bg = tuWen.textBgImage.url;
        }
        this.two = two;
      }
    },
    getDataOne(obj) {
      if (obj) {
        let one = {
          title: obj.title,
          subTitle: obj.subTitle,
          items: [],
        };
        let lieBiao = obj.lieBiao;
        if (lieBiao) {
          for (const v of lieBiao) {
            one.items.push({
              url: v.image.url,
              desc: v.title,
            });
          }
        }
        this.one = one;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
